module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('f7-page', {
    attrs: {
      "name": "401"
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('img', {
    attrs: {
      "src": "/static/images/icons/custom/sad-smile.svg",
      "alt": "sad smile"
    }
  }), _vm._v(" "), _c('h1', [_vm._v("401")]), _vm._v(" "), _c('p', [_vm._v("You are not authorized to access")])])])
},staticRenderFns: []}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-7a3f4354", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-7a3f4354"}!./~/vue-loader/lib/selector.js?type=template&index=0!./scripts/src/pages/401.vue
// module id = 799
// module chunks = 0